export const NFT_GRID = "/";
